
import React, { useEffect, useState } from "react";
import { postData, getData } from '../../../../../ApiServices/ApiService';
import { ORG_GET_ACCOUNTS_INFO } from '../../../../../ApiServices/BaseURL';
import { useLocation, useNavigate } from "react-router-dom";


const InvoiceAccountClientInformationController = () => {

  const location = useLocation();
  const navigate = useNavigate();
  console.log(location)
 

  const [clientInvoiceInfo, setClientInvoiceInfo] = useState({})
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if(location.state?.clientId){
      fetchClientInvoiceInfo(location.state?.clientId)
    }
  }, [location])

  const [invoicesPermissions, setInvoicesPermissions] = useState(null);
  useEffect(() => {
    const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_') || {});
    setInvoicesPermissions(storedUserInfo?.user_permissions?.invoices?.per_name_sub_json || {});
  },[])

  // to check if any permission key is 1
  const hasPermission = (keys) => keys.some(key => invoicesPermissions?.[key] === 1);

  const fetchClientInvoiceInfo = async (clientId) => {
    try {
      setError('');

      setLoading(true);
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      // const locationValue = location === 'Online' ? 2 : 1;
      const payLoad = {
        "emp_id_auth": storedUserInfo?.emp_id,
        "client_id": clientId
      }
      console.log('ToDo status clientId', clientId);
      // Make the API call
      const response = await postData(ORG_GET_ACCOUNTS_INFO, payLoad);
      const responseData = await response.json();
      //console.log('response Data', responseData);

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            if (responseData?.dataJ?.length > 0) {
              setClientInvoiceInfo(responseData?.dataJ[0])
            } else {
              setError(responseData?.info || 'Data Not Found');
            }
          } else {
            setError(responseData?.info || 'Failed to accounts info. Please try again.');
          }
        } else {
          setError(responseData?.info || 'Failed to accounts info.');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
          setError('Unauthorized access. Your session may have expired. Please log in again.');
          // Optionally, redirect to the login page or refresh the token
          // Example: redirectToLogin();
        } else {
          setError(responseData?.info || 'Bad request. Please check the request parameters.');
        }
      }
      // Internal Server Error: 500
      else if (response?.status === 500) {
        setError(responseData?.info || 'Internal Server Error. Please try again later.');
      }
      // Unexpected or network-related errors
      else {
        setError('Unexpected error occurred. Please try again later.');
      }
    } catch (error) {
      // Handle various error scenarios
      if (error.response) {
        // Server responded with a status outside the 2xx range
        setError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to accounts info. Please try again.'}`);
      } else if (error.request) {
        // Request was made but no response was received
        setError('No response received from the server. Please check your network connection and try again.');
      } else {
        // An error occurred in setting up the request
        setError(`Failed to accounts info. Please check your network connection and try again.`);
      }
    } finally {
      setLoading(false);
    }
  }

  const navEstimateListPage = (filterKey)=>{
    if (hasPermission(["estimate_create", "estimate_edit", "estimate_del"])) {
      navigate('/bills-receipts', { state: { selectedTab: 0, filterKey:filterKey, clientId: location.state?.clientId, clientName: clientInvoiceInfo?.client_info?.client_name } })
    }
  }

  const navInvoiceListPage = (filterKey)=>{
    if (hasPermission(["invoice_create", "invoice_edit", "invoice_del"])) {
      navigate('/bills-receipts', { state: { selectedTab: 1, filterKey:filterKey, clientId: location.state?.clientId, clientName: clientInvoiceInfo?.client_info?.client_name } })
    }
  }

  const navReceiptListPage = (filterKey)=>{
    if (hasPermission(["receipt_gen", "receipt_edit"])) {
      navigate('/bills-receipts', { state: { selectedTab: 3, filterKey:filterKey, clientId: location.state?.clientId, clientName: clientInvoiceInfo?.client_info?.client_name } })
    }
  }


  return {
    clientInvoiceInfo,
    loading,error,
    hasPermission,
    navEstimateListPage, navInvoiceListPage, navReceiptListPage
  }

}

export default InvoiceAccountClientInformationController